export default "__VITE_ASSET__Bfjf5gYe__"